<script>
  export let number = 0;

  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  const clickEventHandler = (evt) => {
    navigator.clipboard.writeText(number);
    dispatch("textCopied", {
      text: number,
    });
  };
</script>

<span on:click={clickEventHandler} title="Click to Copy">{number}</span>

<style>
  span {
    cursor: pointer;
  }
</style>
